import * as types from '../actions/actionTypes';

const initialState = {
  permissions: [],
  selectedPermission: null,
  permissionModules: [],
  loading: false,
  error: null,
  meta: {
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 0,
  },
};

const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Permissions
    case types.FETCH_PERMISSIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload.data,
        meta: action.payload.meta,
        error: null,
      };
    case types.FETCH_PERMISSIONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch Single Permission
    case types.FETCH_PERMISSION_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedPermission: action.payload,
        error: null,
      };
    case types.FETCH_PERMISSION_FAILURE:
      return { ...state, loading: false, error: action.payload };


    // Delete permission
    case types.DELETE_PERMISSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case types.DELETE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.filter((perm) => perm.id !== action.payload),
        selectedPermission: null,
        success: 'Permission deleted successfully',
      };
    case types.DELETE_PERMISSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Permission Modules
    case types.FETCH_PERMISSION_MODULES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PERMISSION_MODULES_SUCCESS:
      return {
        ...state,
        loading: false,
        permissionModules: action.payload,
        error: null,
      };
    case types.FETCH_PERMISSION_MODULES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update permission
    case types.UPDATE_PERMISSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case types.UPDATE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.map((perm) =>
          perm.id === action.payload.id ? action.payload : perm
        ),
        selectedPermission: action.payload,
        success: 'Permission updated successfully',
      };
    case types.UPDATE_PERMISSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Permission
    case types.CREATE_PERMISSION_REQUEST:
      return { ...state, loading: true, error: null };
    case types.CREATE_PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: [action.payload, ...state.permissions],
        error: null,
      };
    case types.CREATE_PERMISSION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Clear states
    case types.CLEAR_PERMISSION_SUCCESS:
      return {
        ...state,
        error: null,
        success: null,
      };
    case types.CLEAR_PERMISSION_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default permissionReducer;